/*
 * Returns an object containing all data-* attributes
 * on a node
 */
export const parse = function (node) {
 return [].filter.call(node.attributes, function (node) {
            return node.nodeName.match(/^data\-(.+)$/)
          })
          .reduce(function (p, c) {
            p[c.nodeName.slice(5)] = c.value
            return p
          }, {}) || {}
}

/*
 * Expands an dataset, turning prefixing all keys with `data-`
 * so they can be injected into a node's attributes
 */
export const expand = function (dataset) {
  return Object.keys(dataset || {}).reduce(function (p, key) {
                 p['data-' + key] = dataset[key]
                 return p
               }, {})
}
